import React from 'react';
import validate from 'validate.js';
import { getCountryLabelAndZones, addressFormErrors } from '../../add-a-space/data/addressFormErrors';
import { isEmpty } from 'lodash';
import postalCodes from 'postal-codes-js';
import { FormattedMessage } from 'react-intl';

const validateTaxRegistrationForm = ({
  business_name = '',
  vat_id = '',
  vat_percent = '',
  country = '',
  street = '',
  city = '',
  state = '',
  zip = ''
}, { globalCountries, displayAddressForm, taxIdLength }) => {
  const countryLabelAndZones = getCountryLabelAndZones(globalCountries, country);

  const { selectCountry, enterStreetAddress, enterCity, selectState,
    enterValidPostalCode } = addressFormErrors;
  const { labels = {}, zones = [] } = countryLabelAndZones;

  const selectedCountryHasZones = !isEmpty(zones);

  validate.validators.isValidZip = (value) => {
    const zipCheck = postalCodes.validate(country, value);
    return true === zipCheck
      ? undefined
      : enterValidPostalCode[labels.postalCode || 'Postal code'];
  };

  const addressFieldValidations = displayAddressForm ? {
    country: validate.single(country,
      {
        presence: {
          allowEmpty: false,
          message: selectCountry
        }
      }),
    street: validate.single(street,
      {
        presence: {
          allowEmpty: false,
          message: enterStreetAddress
        }
      }),
    city: validate.single(city,
      {
        presence: {
          allowEmpty: false,
          message: enterCity[labels.city || 'City']
        }
      }),
    state: validate.single(state,
      {
        presence: {
          allowEmpty: !selectedCountryHasZones,
          message: selectState[labels.zone || 'State']
        }
      }),
    zip: validate.single(zip,
      {
        isValidZip: true
      })
  } : {};

  return {
    business_name: validate.single(business_name,
      {
        presence: {
          allowEmpty: false,
          message: <FormattedMessage
            id='hosting.tax_registration_form.business_name'
            defaultMessage='Please enter business name.' />
        }
      }),
    vat_id: validate.single(vat_id,
      {
        length: { is: taxIdLength,
          message: <FormattedMessage
            id='hosting.tax_registration_form.tax_id'
            defaultMessage='Enter your ID as {idLength} characters without punctuation.'
            values={{ idLength: taxIdLength }} />
        },
        presence: {
          allowEmpty: false,
          message: <FormattedMessage
            id='hosting.tax_registration_form.tax_id'
            defaultMessage='Enter your ID as {idLength} characters without punctuation.'
            values={{ idLength: taxIdLength }} />
        }
      }),
    vat_percent: validate.single(vat_percent,
      {
        numericality: {
          greaterThanOrEqualTo: 0,
          lessThan: 35,
          message: <FormattedMessage
            id='hosting.tax_registration_form.tax_rate'
            defaultMessage='Enter the % as digits only. Number must be less than 35.' />
        },
        presence: {
          allowEmpty: false,
          message: <FormattedMessage
            id='hosting.tax_registration_form.tax_rate'
            defaultMessage='Enter the % as digits only. Number must be less than 35.' />
        }
      }),
    ...addressFieldValidations
  };
};

export default validateTaxRegistrationForm;
